import styled from 'styled-components';
import { colors } from 'app/variables';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px;
  position: relative;
  color: ${colors.pacificBlue};
`;
export const PriceDisplay = styled.div`
  color: initial;
  line-height: normal;
  font-size: 2.25rem;
  font-weight: 800;
  padding-bottom: 1rem;

  padding-top: ${({ missingLogo }) => missingLogo && '1rem'};
`;
export const SuccessfulFormContainer = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 1rem;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${colors.pacificBlue};
  border-radius: 6px;
  text-align: center;
  line-height: 1.5;
  height: 100%;
  width: 100%;
`;
export const PurchaseDetails = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  width: 100%;

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      text-align: left;
    }
  }
`;
export const IconContainer = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2rem;
`;
export const ConfirmationText = styled.div`
  padding: 0 1rem 1rem 1rem;
  margin-top: 1rem;
  text-align: center;
  color: ${colors.pacificBlue};
  font-size: 0.8rem;
`;
